module.exports = __webpack_public_path__ + "img/photos/office@2x.jpg";